/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PlatformType } from "./platform-type";
import { PlatformUserAgent } from "./platform-user-agent";
import { PlatformDeviceInfo } from "./platform-device-info";

enum WebOSStatus {
    CONNECTED = "connected",
    DISCONNECTED = "disconnected",
}

export enum WebOSSDKVersion {
    Unknown = "unknown",
    V5 = "5.x.x",
    V6 = "6.x.x",
    V7 = "7.x.x",
    V8 = "8.x.x",
    V9 = "9.x.x",
}

export class PlatformWebOS extends PlatformUserAgent {
    private osVersion: string | null = null;

    constructor() {
        super(PlatformType.WebOS)
    }

    public static matchThisPlatform(): boolean {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return !!(<any>window).webos;
    }

    isSupported(): boolean {
        return true;
    }

    private request(uri: string, parameters = {}): Promise<any> {
        if (!(window as any)?.webOS) {
            return Promise.reject(new Error(`WebOS service is not available. Cannot request: ${uri}`));
        }
        return new Promise((resolve, reject) => {
            (window as any)?.webOS?.service?.request(uri, {
                ...parameters,
                onSuccess: (inResponse: any) => {
                        const isSucceeded = inResponse.returnValue;

                        if (isSucceeded) {
                            resolve(inResponse);
                        } else {
                            reject(new Error(`Failed to get TV device information for: ${uri}`));
                            return;
                        }
                    },
                onFailure: reject,
            });
        });
    }

    async getDeviceInfo(): Promise<PlatformDeviceInfo> {
        const baseInfo = await super.getInfo();

        let modelName = "", firmwareVersion = "", wifiMacAddress = "", cableMacAddress = "", ssid = "";
        let wifiStatus = "", cableStatus = null, cablePlugged = false;

        try {
            const systemInfo = await this.request("luna://com.webos.service.tv.systemproperty", {
                method: 'getSystemInfo',
                parameters: {
                    keys: ['modelName', 'firmwareVersion', 'sdkVersion'], // 'UHD', can be added if needed
                },
            });
            modelName = systemInfo.modelName;
            firmwareVersion = systemInfo.firmwareVersion;
            this.osVersion = systemInfo?.sdkVersion ?? null;
        } catch(err) {
            console.error("Failed to get model and firmware version:", err);
        }

        try {
            const net = await this.request("luna://com.webos.service.connectionmanager", { method: "getStatus" });
            ssid = net.wifi.ssid ?? "";
            wifiStatus = net.wifi.state;
            cableStatus = net.wired.state;
            cablePlugged = net.wired.plugged ?? false;
        } catch(err) {
            console.error("Failed to get connectionmanager status:", err);
        }

        try {
            const net = await this.request("luna://com.webos.service.connectionmanager", { method: "getinfo" });
            wifiMacAddress = net.wifiInfo.macAddress ?? "";
            cableMacAddress = net.wiredInfo.macAddress ?? "";
        } catch(err) {
            console.error("Failed to get connectionmanager info:", err);
        }

        return new PlatformDeviceInfo(
            wifiStatus === WebOSStatus.CONNECTED ? wifiMacAddress : cableMacAddress || baseInfo.macAddress,
            {
                model: modelName,
                manufacturer: "LG Electronics",
                buildVersion: firmwareVersion,
            },
            {
                macAddress: wifiMacAddress,
                signalStrength: null,
                ssid,
                status: wifiStatus as any,
            },
            {
                status: cableStatus as any,
                macAddress: cableMacAddress,
                cable: cablePlugged ? "ATTACHED" : "DETACHED",
            }
        );
    }

    public getOSVersion(): string | null{
        return this.osVersion;
    }
};